export interface IServiceProduct {
  id: string
  branchId: string
  name: string
  description: string
  active: boolean
  category: string
  price: number
  taxable: boolean
  duration: number
  initialServiceCode: string
  initialPrice: number
  taxableInStates: string[]
  annualOccurrences: number
  frequency: string
  serviceType: SERVICE_TYPE
  metadata: IServiceProductMetadata | null
  targetPests: ITargetPest[] | null
}

export interface IServiceProductMetadata {
  [k: string]: string
}

export interface ITargetPest {
  id: string
  type: number
  name: string
  description: string
}

export enum SERVICE_TYPE {
  SERVICE,
  PRODUCT,
}

export interface IServiceProductReorderFormSetting {
  serviceProductId: number
  enabled: boolean
  order: number
  required: boolean
  name: string
}
